import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import GroupCard from "../components/GroupCard";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "../components/ExtendedLink";

class TopCategories extends Component {
  render() {
      const { t, groups, settings } = this.props;
    if (!groups) return <div />;

    const groupsList = groups.items.slice(0, 3).map(group => (
        <GroupCard key={group.id} group={group} smCols={6} mdCols={4} baseUrl={settings.baseUrl}/>
    ));

      return (
          // <!-- Top Categories-->
          <section className="container padding-top-3x">
              <h3 className="text-center mb-30">{t("Top Categories")}</h3>
              <div className="row ">
                  {groupsList}
              </div>
              <div className="text-center">
                  <ExtendedLink
                      className="btn btn-outline-secondary margin-top-none"
                      to={`${settings.baseUrl}categories`}
          >
                    {t("All Categories")} 
          </ExtendedLink>
        </div>
      </section>
    );
  }
}


function mapStateToProps({ groups, settings }) {
    return { groups, settings };
}

export default withTranslation()(connect(mapStateToProps, null)(TopCategories));

